import React, { useState } from "react";
import { Image } from "semantic-ui-react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const LightboxImage = ({
  className,
  src,
  photoIndex,
  imageArray,
  ...otherProps
}) => {
  const [isOpen, setOpen] = useState(false);
  const [currentPhotoIndex, setPhotoIndex] = useState(photoIndex || 0);

  return (
    <React.Fragment>
      <Image
        {...otherProps}
        src={src}
        style={{ cursor: "pointer" }}
        onClick={() => setOpen(true)}
      />
      {isOpen && (
        <Lightbox
          wrapperClassName={className}
          mainSrc={imageArray ? imageArray[currentPhotoIndex] : src}
          nextSrc={
            imageArray && imageArray.length > 1
              ? imageArray[(currentPhotoIndex + 1) % imageArray.length]
              : null
          }
          prevSrc={
            imageArray && imageArray.length > 1
              ? imageArray[
                  (currentPhotoIndex + imageArray.length - 1) %
                    imageArray.length
                ]
              : null
          }
          onCloseRequest={() => setOpen(false)}
          onMovePrevRequest={() =>
            imageArray &&
            imageArray.length > 1 &&
            setPhotoIndex(
              (currentPhotoIndex + imageArray.length - 1) % imageArray.length,
            )
          }
          onMoveNextRequest={() =>
            imageArray &&
            imageArray.length > 1 &&
            setPhotoIndex((currentPhotoIndex + 1) % imageArray.length)
          }
          imagePadding={40}
        />
      )}
    </React.Fragment>
  );
};

export default LightboxImage;
